import Constant from 'BASE/common/lotteryConstant';
export default {
    data() {
        return {
            maxCollect: 10,
            collectionType: Constant.CollectionType.GAME
        };
    },
};